export const environment = {
    name: "stg",
    production: false,
    rootAuthnUrl: "https://stg.authn.spectrumreach.io",
    baseBreUrl: "https://stg.xdds.spectrumreach.io",
    baseUrl: "https://stg.admin.spectrumreach.io",
    adminPermissionName: "adminUIAccess",
    cognito: {
        customProviderName: "ESSO",
        Auth: {
            region: "us-east-1",
            userPoolId: "us-east-1_wEel2mD2N",
            userPoolWebClientId: "5ike6c3gcm8lqa3rmjjcbqmpvs",
        },
        oauth: {
            domain: "srd-user-pool-stg.auth.us-east-1.amazoncognito.com",
            redirectSignIn: "https://stg.admin.spectrumreach.io/",
            redirectSignOut: "https://stg.admin.spectrumreach.io/",
            responseType: "token",
        }
    },
    allowCognitoAuth: true
};